import { hmapPathParamConfig, hmapPathParamRegex } from "@ngmodules/hmap/hmap.routes";
export const JobTemplatesRoutes = [
    {
        "url": "/brand/:brand_id/job-templates?tab",
        "name": "appLayout.harriSH.jobTemplates",
        "type": "frontend",
        "reloadOnSearch": false,
        "loginRequired": true,
        "showGlobalSearch": true,
        "component": 'jobTemplates',
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["job-screening-templates", 'centralized-settings']
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Harri | Job Templates"
            }
        ],
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/job-templates/job-templates.downgrade.module");
                }
            },
        ]
    },
    {
        "url": `/job-templates/${hmapPathParamRegex}?tab`,
        "name": "appLayout.harriSH.access-portal.settings.jobTemplates",
        "showSettingsHeader": true,
        "type": "frontend",
        "params": {
            ...hmapPathParamConfig
        },
        "reloadOnSearch": false,
        "loginRequired": true,
        "showGlobalSearch": true,
        "component": 'jobTemplates',
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["job-screening-templates", 'centralized-settings']
        },
        "onEnter": ['$stateParams', '$state', 'hmapService', 'userPermissions', async function ($stateParams, $state, hmapService, userPermissions) {
                const activeBrandId = hmapService.getActiveBrandId($stateParams['hmapPath']);
                const policyParser = await userPermissions.getBrandPolicy(activeBrandId);
                if (!policyParser.has(userPermissions.PERMISSIONS['CREATE_EDIT_JOB_POST']) || !policyParser.hasAccess(userPermissions.ACCESS_TYPES.SOURCE_HIRE)) {
                    Utils.redirectToWorkspace('appLayout.harriSH.access-portal.main', { hmapPath: $stateParams['hmapPath'] });
                }
                const gpPolicy = await hmapService.loadGPPlociy(activeBrandId);
                const activeBrandPolicy = gpPolicy?.brands?.find((entry) => entry.id === activeBrandId);
                if (activeBrandPolicy?.actions[0] !== 'ALL') {
                    Utils.redirectToWorkspace('appLayout.harriSH.access-portal.main', { hmapPath: $stateParams['hmapPath'] });
                }
            }
        ],
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Harri | Job Templates"
            }
        ],
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/job-templates/job-templates.downgrade.module");
                }
            },
        ]
    },
    {
        "url": "/screening-questions/create?brand_id&is_settings&template_id&edit_mode",
        "name": "appLayout.harriSH.create-screening-questions",
        "type": "frontend",
        "loginRequired": true,
        "showGlobalSearch": true,
        "component": 'createScreeningQuestionsTemplateContainer',
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["job-screening-templates", 'centralized-settings']
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/job-templates/job-templates.downgrade.module");
                }
            }
        ]
    },
    {
        "url": `/screening-questions/create/${hmapPathParamRegex}?brand_id&is_settings&template_id&edit_mode`,
        "name": "appLayout.harriSH.access-portal.create-screening-questions",
        "type": "frontend",
        "params": {
            ...hmapPathParamConfig
        },
        "loginRequired": true,
        "showGlobalSearch": true,
        "component": 'createScreeningQuestionsTemplateContainer',
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["job-screening-templates", 'centralized-settings']
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/job-templates/job-templates.downgrade.module");
                }
            }
        ]
    },
    {
        "url": "/ai-screening-questions/create?brandId&templateId&isSettings",
        "name": "appLayout.harriSH.create-ai-screening-questions",
        "type": "frontend",
        "loginRequired": true,
        "showGlobalSearch": true,
        "component": 'aiScreeningQuestionsSetupWizardContainer',
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ['centralized-settings']
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/job-templates/job-templates.downgrade.module");
                }
            }
        ]
    },
    {
        "url": `/ai-screening-questions/create/${hmapPathParamRegex}?brandId&templateId&isSettings`,
        "name": "appLayout.harriSH.access-portal.create-ai-screening-questions",
        "type": "frontend",
        "params": {
            ...hmapPathParamConfig
        },
        "loginRequired": true,
        "showGlobalSearch": true,
        "component": 'aiScreeningQuestionsSetupWizardContainer',
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ['centralized-settings']
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/job-templates/job-templates.downgrade.module");
                }
            }
        ]
    },
    {
        "url": "/:view?tab",
        "name": "appLayout.harriSH.settings.brandSection",
        "type": "frontend",
        "showGlobalSearch": true,
        "loginRequired": true,
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["job-screening-templates", 'centralized-settings']
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("@ngmodules/job-templates/job-templates.downgrade.module");
                }
            }
        ]
    },
];
//# sourceMappingURL=job-templates.routes.js.map